/* unplugin-vue-components disabled */import { render } from "./service_phone.vue?vue&type=template&id=438674d7&scoped=true"
import script from "./service_phone.vue?vue&type=script&lang=js"
export * from "./service_phone.vue?vue&type=script&lang=js"

import "./service_phone.vue?vue&type=style&index=0&id=438674d7&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438674d7"]])

export default __exports__